import PropTypes from 'prop-types'
import React from 'react'
import { components } from 'react-select'
import SimpleBar from 'simplebar-react'

import './MenuList.scss'

const MenuList = ({ children, ...props }) => {
  return (
    <components.MenuList {...props} className="select-menu-list">
      <SimpleBar>{children}</SimpleBar>
    </components.MenuList>
  )
}

MenuList.propTypes = {
  children: PropTypes.node.isRequired,
}

export default MenuList
